/**
 * Created by vladislav on 22.03.2021
 */

const SlotMachineSymbolView = cc.Node.extend({
    ctor: function (symbol) {
        this._super();

        this.symbol = symbol;
        this.reel = this.symbol.reel;

        const styles = cleverapps.styles.SlotMachineSymbolView;

        this.setContentSize2(styles);
        this.setAnchorPoint(0.5, 0.5);

        const icon = new cc.Sprite(symbol.icon);
        this.addChild(icon);
        icon.setAlignment(this.width / 2, this.height / 2);

        symbol.on("move", this.createListener(this.move.bind(this)));
        symbol.on("spin", this.createListener(this.spinOneDegree.bind(this)));
        symbol.on("animate", this.createListener(this.animate.bind(this)));
        symbol.on("reset", this.createListener(this.reset.bind(this)));

        this.setAlignment(this.calcPosition());

        this.setCascadeColorEnabled(true);
    },

    reset: function () {
        this.stopAllActions();

        if (this.shine) {
            this.shine.removeFromParent();
            delete this.shine;
        }

        this.setColor(cleverapps.styles.COLORS.WHITE);
    },

    animate: function (highlight) {
        if (highlight) {
            this.shine = new cleverapps.Spine(bundles.slot_machine.jsons.shine_json);
            this.addChild(this.shine);
            this.shine.setSkin(this.symbol.type);
            this.shine.setAnimation(0, "animation", false);
            this.shine.setAlignment(this.width / 2, this.height / 2);
            this.shine.setCompleteListenerRemove();
        } else {
            this.runAction(new cc.Sequence(
                new cc.TintTo(0.2, 120, 120, 120),
                new cc.DelayTime(5),
                new cc.TintTo(0.2, 255, 255, 255)
            ));
        }
    },

    move: function () {
        this.setAlignment(this.calcPosition());
    },

    spinOneDegree: function (isLast) {
        const styles = cleverapps.styles.SlotMachineSymbolView;

        const targetPos = this.calcPosition();
        if (isLast) {
            this.runAction(new cc.Sequence(
                new cc.MoveBy(SlotMachineReel.ONE_DEGREE_DURATION / 1000, 0, -styles.height - styles.height / 2).easing(cc.easeBackInOut(0.6)),
                cleverapps.effects.fireAction("slotmachine.spin.stop"),
                new cc.MoveBy(0.1, 0, styles.height / 2 + styles.height / 8),
                new cc.MoveBy(0.1, 0, -styles.height / 8).easing(cc.easeIn(2)),
                new cc.CallFunc(() => {
                    this.setAlignment(targetPos);
                })
            ));
        } else {
            this.runAction(new cc.Sequence(
                new cc.MoveBy(SlotMachineReel.ONE_DEGREE_DURATION / 1000, 0, -styles.height),
                new cc.CallFunc(() => {
                    this.setAlignment(targetPos);
                })
            ));
        }

        cleverapps.effects.fire("slotmachine.spin");
    },

    calcPosition: function () {
        const styles = cleverapps.styles.SlotMachineSymbolView;

        const bottomSymbolIndex = (this.reel.getCurrent().index + 1) % this.reel.symbols.length;
        const indexOffset = (bottomSymbolIndex - this.symbol.index + this.reel.symbols.length) % this.reel.symbols.length;

        const centerOffset = cleverapps.styles.SlotMachineReelView.height / 2 - (styles.height / 2 + styles.height);

        return cc.p(this.width / 2, styles.height / 2 + indexOffset * styles.height + centerOffset);
    }
});

cleverapps.styles.SlotMachineSymbolView = {
    width: 150,
    height: 150,

    lastAnimation: {

    }
};